import { createAction } from 'redux-actions';

import productTypes from './types';

export function createProductActions(types = productTypes) {
    const setProduct = createAction(types.SET_PRODUCT);
    const loadProduct = createAction(types.LOAD_PRODUCT);
    const setLoading = createAction(types.SET_LOADING);
    const setFocused = createAction(types.SET_FOCUSED);
    const loadProductVariantData = createAction(types.LOAD_PRODUCT_VARIANT_DATA);
    const updateProductWithVariantData = createAction(types.UPDATE_PRODUCT_WITH_VARIANT_DATA);
    const updateProductWithVariantPriceData = createAction(
        types.UPDATE_PRODUCT_WITH_VARIANT_PRICE_DATA,
    );
    const resetStore = createAction(types.RESET);
    const setQuantity = createAction(types.SET_QUANTITY);
    const setProductCodeToBeRemoved = createAction(types.SET_PRODUCT_CODE_TO_BE_REMOVED);
    const setProductDataForAddProductReview = createAction(
        types.SET_PRODUCT_DATA_FOR_ADD_PRODUCT_REVIEW,
    );
    const setInitialQuantity = createAction(types.SET_INITIAL_QUANTITY);
    const removeInitialQuantity = createAction(types.REMOVE_INITIAL_QUANTITY);
    const showInformMeOnly = createAction(types.SHOW_INFORM_ME_ONLY);
    const customCssLoaded = createAction(types.CUSTOM_CSS_LOADED);

    const colorVariantsPopupSelect = createAction(types.COLOR_VARIANTS_POPUP_SELECT);
    const colorVariantsPopupUpdate = createAction(types.COLOR_VARIANTS_POPUP_UPDATE);
    const colorVariantsPopupSync = createAction(types.COLOR_VARIANTS_POPUP_SYNC);
    const colorVariantsPopupSubmit = createAction(types.COLOR_VARIANTS_POPUP_SUBMIT);
    const showProductDetails = createAction(types.SHOW_PRODUCT_DETAILS);

    const loadProductHomeDeliveryDate = createAction(types.LOAD_PRODUCT_HOME_DELIVERY_DATE);
    const loadProductPickupInStoreDeliveryDate = createAction(
        types.LOAD_PRODUCT_PICKUP_IN_STORE_DELIVERY_DATE,
    );
    const setProductHomeDeliveryDate = createAction(types.SET_PRODUCT_HOME_DELIVERY_DATE);
    const setProductPickupInStoreDeliveryDate = createAction(
        types.SET_PRODUCT_PICKUP_IN_STORE_DELIVERY_DATE,
    );
    const clearProductVideo = createAction(types.CLEAR_PRODUCT_VIDEO);
    const productImpressionView = createAction(types.PRODUCT_IMPRESSION_VIEW);

    const setBundleProduct = createAction(types.SET_BUNDLE_PRODUCT);
    const setThresholdPromotion = createAction(types.SET_THRESHOLD_PROMOTION_OBJECT);
    return {
        setProduct,
        loadProduct,
        productImpressionView,
        setLoading,
        setFocused,
        loadProductVariantData,
        updateProductWithVariantData,
        resetStore,
        updateProductWithVariantPriceData,
        setQuantity,
        setProductCodeToBeRemoved,
        setProductDataForAddProductReview,
        setInitialQuantity,
        removeInitialQuantity,
        colorVariantsPopupSelect,
        colorVariantsPopupUpdate,
        colorVariantsPopupSync,
        colorVariantsPopupSubmit,
        showInformMeOnly,
        showProductDetails,
        loadProductHomeDeliveryDate,
        loadProductPickupInStoreDeliveryDate,
        setProductHomeDeliveryDate,
        setProductPickupInStoreDeliveryDate,
        customCssLoaded,
        clearProductVideo,
        setBundleProduct,
        setThresholdPromotion,
    };
}

export default createProductActions();
